import styled from "styled-components";

export const HeaderWrapper = styled.div<{
    hasTopPadding?: boolean;
    hasBottomPadding?: boolean;
    topPaddingColor?: string;
    bottomPaddingColor?: string;
}>(({ theme, hasTopPadding = true, hasBottomPadding = true, topPaddingColor, bottomPaddingColor }) => {
    const defaultBgColor = theme.colors[theme.colorMode].background_Primary;
    const topColor = topPaddingColor || defaultBgColor;
    const bottomColor = bottomPaddingColor || defaultBgColor;
    const needsTopColor = hasTopPadding && topPaddingColor;
    const needsBottomColor = hasBottomPadding && bottomPaddingColor;
    return {
        backgroundColor: defaultBgColor,
        position: "relative",
        "@supports (padding-top: var(--sat))": {
            paddingTop: hasTopPadding ? "var(--sat)" : 0,
        },
        "@supports (padding-bottom: var(--sab))": {
            paddingBottom: hasBottomPadding ? "var(--sab)" : 0,
        },
        ...(needsTopColor && {
            "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "var(--sat)",
                backgroundColor: topColor,
                zIndex: 0,
            },
        }),
        ...(needsBottomColor && {
            "&::after": {
                content: '""',
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                height: "var(--sab)",
                backgroundColor: bottomColor,
                zIndex: 0,
            },
        }),
        "#cta-list-container": {
            marginBottom: "-1px",
        },
    };
});

export const PageContainer = styled.div<{
    hasTopPadding?: boolean;
    hasBottomPadding?: boolean;
    hasBottomBar?: boolean;
}>(({ theme, hasTopPadding = true, hasBottomPadding = true, hasBottomBar = false }) => {
    const topPadding = hasTopPadding ? "var(--sat)" : "0px";
    const bottomPadding = hasBottomPadding ? "var(--sab)" : "0px";
    const bottomBarHeight = hasBottomBar ? "82px" : "0px";
    return {
        width: "100vw",
        maxWidth: "100vw",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        height: `calc(100dvh - ${topPadding} - ${bottomPadding} - ${bottomBarHeight})`,
        minHeight: `calc(100dvh - ${topPadding} - ${bottomPadding} - ${bottomBarHeight})`,

        // Fallback: older browsers / iOS webviews
        "@supports not (height: 100dvh)": {
            minHeight: `calc(100vh - ${topPadding} - ${bottomPadding} - ${bottomBarHeight})`,
            height: `calc(100vh - ${topPadding} - ${bottomPadding} - ${bottomBarHeight})`,
        },

        background:
            theme.colorMode === "light" ? theme.colors.light.background_Secondary : theme.colors.dark.canvas_Primary,
    };
});

export const StyledTitleBar = styled.div(({ theme }) => ({
    position: "sticky",
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    top: 0,
    zIndex: 1,
    flexShrink: 0,
}));

export const TabsContainer = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing.xLarge,
    marginBottom: theme.spacing.medium,
    backgroundColor:
        theme.colorMode === "light" ? theme.colors.light.background_Secondary : theme.colors.dark.canvas_Primary,
    flexShrink: 0,
}));

export const ContentWrapper = styled.div(({ theme }) => ({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    minHeight: 0,
    "#cta-list-container": {
        zIndex: theme.elevation[theme.colorMode].skim.zIndex,
    },
}));

export const ErrorWrapper = styled.div({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
});

export const TabContent = styled.div<{ isVisible: boolean }>(({ isVisible }) => ({
    flex: 1,
    display: isVisible ? "flex" : "none",
    flexDirection: "column",
    overflow: "auto",
    minHeight: 0,
}));
